module.exports = __webpack_public_path__ + "static/img/z-9.c030de7d.png";